import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, err, when } from "../../lib/api";

const KINDS = ["deposit", "withdrawal", "transactions", "game", "bets", "bonus", "users", "audit"];

export default function AdminReports() {
  const [logs, setLogs] = useState([]);
  const loadLogs = () => api.get("/admin/audit").then(r => setLogs(r.data)).catch(() => {});
  useEffect(() => { loadLogs(); }, []);
  const download = async kind => {
    try {
      const r = await api.get("/admin/reports.csv", { params: { kind }, responseType: "blob" });
      const url = URL.createObjectURL(r.data), a = document.createElement("a");
      a.href = url; a.download = `laxmiwin-${kind}-report.csv`; a.click(); URL.revokeObjectURL(url);
      loadLogs();
    } catch (e) { toast.error(err(e)); }
  };
  return (
    <>
      <section className="admin-section"><div className="section-head"><h2>CSV reports</h2><span className="report-note">Download data as CSV</span></div>
        <div className="report-grid">{KINDS.map(k => <button key={k} onClick={() => download(k)} data-testid={`download-${k}-report-button`}>↓ {k} CSV</button>)}</div></section>
      <section className="admin-section"><h2>Audit log</h2><div className="audit-list" data-testid="audit-log-list">
        {logs.map((l, i) => <div key={i}><b>{l.action}</b> · {l.admin_phone || l.admin_id} <small>· {when(l.created_at)}</small><br /><small>{Object.entries(l).filter(([k]) => !["action", "admin_id", "admin_phone", "created_at"].includes(k)).map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(",") : v}`).join(" · ")}</small></div>)}
      </div></section>
    </>
  );
}
